import { defineStore } from 'pinia'
import { ref } from 'vue'

const useWishlistStore = defineStore('wishlist', () => {
  const collections = ref<Wishlist[]>([])
  const items = ref<WishlistItem[]>([])
  const selectedCollection = ref<Wishlist>()
  const selectedItem = ref<WishlistItem>()
  const refetchCollections = ref(false)
  const refetchSelectedCollection = ref(false)
  const refetchItems = ref(false)

  return {
    collections,
    items,
    selectedCollection,
    selectedItem,
    refetchCollections,
    refetchSelectedCollection,
    refetchItems
  }
})

export default useWishlistStore
